import { useState } from "react";
import { ArrowRight, LoaderCircle, LockKeyhole, UserRound } from "lucide-react";
import { api, setToken } from "../api";

export function Login({ onLogin }: { onLogin: () => void }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  async function submit(event: React.FormEvent) {
    event.preventDefault(); setLoading(true); setError("");
    try {
      const result = await api<{ token: string }>("/api/auth/login", { method: "POST", body: JSON.stringify({ username, password }) });
      setToken(result.token); onLogin();
    } catch { setError("登录未成功，请检查账号信息后重试"); }
    finally { setLoading(false); }
  }
  return <main className="login-page">
    <section className="login-box">
      <div className="login-brand"><span className="brand-mark"><img src="/yida-logo.png" alt="亿大口腔" /></span><div><strong>亿大口腔智能体</strong><small>客服分析与知识沉淀系统</small></div></div>
      <div className="login-heading"><h1>登录工作台</h1><p>进入对话分析与团队知识库</p></div>
      <form onSubmit={submit}>
        <label>账号<div className="input-with-icon"><UserRound size={17} /><input autoFocus type="text" autoComplete="username" value={username} onChange={(e) => setUsername(e.target.value)} required /></div></label>
        <label>密码<div className="input-with-icon"><LockKeyhole size={17} /><input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required /></div></label>
        {error && <div className="form-error">{error}</div>}
        <button className="button primary login-button" disabled={loading}>{loading ? <LoaderCircle className="spin" size={18} /> : <ArrowRight size={18} />}登录</button>
      </form>
    </section>
  </main>;
}
